// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"52":"1926aee59ef027ff","377":"b201a54b1246c97b","415":"33dee2100f0a50bd","538":"cd140c3d731aed86","767":"f972996417007120","983":"74000e5117bfeb38"}[chunkId] + ".js";
};